import { ACTION_CONTEXTS, FintechOutageBannerWithFetch } from 'account-and-billing-fintech-outages';
import { Flex } from 'foundations-components/components/Flex';
import Raven from 'raven-js';
import { useCallback, useEffect, useRef } from 'react';
import RussianBlockedBanner from 'pricing-pages-ui-components/banners/RussianBlockedBanner';
import { isDismissableDesignType } from '../../hooks/useDynamicBanners';
import { trackBannerInteraction } from '../../utils/tracking';
import { DynamicBanner } from './DynamicBanner';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PublicBannerSection = ({
  countryCode,
  banners,
  onDismissBanner,
  screen
}) => {
  const trackedBannerNames = useRef(new Set());
  useEffect(() => {
    if (!screen) {
      return;
    }
    for (const {
      banner
    } of banners) {
      const name = String(banner.bannerName);
      if (!trackedBannerNames.current.has(name)) {
        trackedBannerNames.current.add(name);
        trackBannerInteraction({
          action: 'view',
          name,
          screen
        });
      }
    }
  }, [banners, screen]);
  const handleFintechOutageError = useCallback(error => {
    if (error === undefined || (error === null || error === void 0 ? void 0 : error.status) === 0) {
      return;
    }
    Raven.captureException(error);
  }, []);
  const renderBanners = () => {
    if (countryCode === 'RU') {
      return /*#__PURE__*/_jsx(RussianBlockedBanner, {});
    }
    if (banners.length === 0) {
      return null;
    }
    return /*#__PURE__*/_jsx(_Fragment, {
      children: banners.map(({
        banner,
        purchaseMotionCTA
      }) => /*#__PURE__*/_jsx(DynamicBanner, {
        headline: banner.headline,
        description: typeof banner.description === 'string' ? banner.description : undefined,
        designType: banner.designType,
        bannerType: banner.bannerType,
        purchaseMotionCTA: purchaseMotionCTA,
        onDismiss: isDismissableDesignType(banner.designType) ? () => onDismissBanner(banner) : undefined
      }, String(banner.bannerName)))
    });
  };
  return /*#__PURE__*/_jsxs(Flex, {
    display: "flex",
    flexDirection: "column",
    inlineSize: "100%",
    rowGap: "400",
    marginBlockEnd: "400",
    "data-test-id": "public-banner-section-container",
    children: [/*#__PURE__*/_jsx(FintechOutageBannerWithFetch, {
      actionContext: ACTION_CONTEXTS.PURCHASE,
      onError: handleFintechOutageError
    }), renderBanners()]
  });
};